import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_INFORMATION_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_INFORMATION,
} from '@modules/general-settings/submodules/information/constants';
import { useI18n } from '@modules/i18n/composables';
import useStaticPageConfig from '@modules/static-pages/composables/useStaticPageConfig';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsInformationModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    const { getStaticPagesPermissions } = useStaticPageConfig();

    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_INFORMATION_ROUTE_NAME,
      path: 'information',
      permission: getStaticPagesPermissions(),

      component: () => import('@modules/general-settings/submodules/information/pages/AdminGeneralSettingsInformationPage/AdminGeneralSettingsInformationPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();
    const { getStaticPagesPermissions } = useStaticPageConfig();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_INFORMATION, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_INFORMATION_ROUTE_NAME,
      },
      permission: getStaticPagesPermissions(),
      id: ADMIN_GENERAL_SETTINGS_INFORMATION_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_INFORMATION, getTranslationKeys);
  }
}
